import { useState, useEffect } from 'react';
import styles from './FloatingContact.module.scss';

export default function FloatingContact() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            // Show after scrolling down a bit
            setIsVisible(window.scrollY > 300);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handlePhoneClick = () => {
        window.location.href = 'tel:+4917662269207';
    };

    const handleEmailClick = () => {
        window.location.href = 'mailto:kontakt@koricode.de';
    };

    if (!isVisible) return null;

    return (
        <div className={styles.floatingContact} data-aos="fade-left">
            <a
                href="tel:+4917662269207"
                className={styles.contactButton}
                onClick={(e) => {
                    e.preventDefault();
                    handlePhoneClick();
                }}
                aria-label="Anrufen"
            >
                <i className="bx bx-phone"></i>
            </a>
            <a
                href="mailto:kontakt@koricode.de"
                className={styles.contactButton}
                onClick={(e) => {
                    e.preventDefault();
                    handleEmailClick();
                }}
                aria-label="E-Mail senden"
            >
                <i className="bx bx-envelope"></i>
            </a>
        </div>
    );
}
